import React, { Component } from 'react';
import $ from 'jquery';
import '../css/dataTables.css';
import {renderTableName} from "./index";
import { ContactPersons } from './NewOrder';
let headers = [
    {title: 'Tabla'}
];

class QueryPreviewManagerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            tablas: [],
            propSelected:[],
            array: [],
            checklist:[],
            checkboxDataTables: (new Map(): Map<string, boolean>),
        };
        this.newModelCopy = '';
    }
    componentDidMount(): void {
        this.closeAction();
    }

    closeQuery= async () => {
        $('#queryPreviewManager').modal('hide');
    };
    closeAction = () => {
        $('#queryPreviewManager').on('hide.bs.modal', function () {
        });
    };
  
    render() {
        const {titleModal} = this.props;
       
        return (
            <div className="modal fade bd-example-modal-lg bgtransparent" id="queryPreviewManager" style={{zIndex:91}} role="dialog"
             aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-lg " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                             <h4 className="modal-title" id="modal-basic-title ">{titleModal}</h4>
                            <button type="button" className="close" onClick={this.closeQuery}  aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row">
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeQuery} >Ejecutar</button>
                
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeQuery} >Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default QueryPreviewManagerModal;